import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://scripture-souls.onrender.com';
export const API_BASE = `${BACKEND_URL}/api`;

// Credentialed instance — for auth/me, bookmarks, flashcards, admin actions (need cookies)
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Public instance — for /characters, /books, /character-of-the-day (no cookies)
// Avoids preflight + cookie issues in iframes/cross-origin contexts.
export const publicApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});
